import { SharedFormSelect, FormSelectProps as Props } from '@agro-club/agroclub-shared'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'

export type FormSelectSharedProps = Omit<Props, 'apiClient'>

const FormSelectShared: FC<FormSelectSharedProps> = (props) => <SharedFormSelect apiClient={apiClient} {...props} />

export default FormSelectShared
